<template>
  <div>
    <VuepalWebform
      v-bind="webform"
      :submit-form="submitForm"
      :submit-label="$texts('submit', 'Senden')"
      form-class="grid"
      @success="onSuccess"
    />
  </div>
</template>

<script lang="ts" setup>
import type {
  WebformSubmissionResultFragment,
  WebformFragment,
  SubmitWebformMutationVariables,
} from '#graphql-operations'
import type { MutationVariables } from '~/layers/webform/types/webform'

const props = defineProps<{
  webform: WebformFragment
  sourceEntityId?: string
  sourceEntityType?: string
}>()

async function submitForm(
  input: MutationVariables,
): Promise<WebformSubmissionResultFragment> {
  if (!props.webform?.id) {
    throw new Error('Missing webform ID')
  }
  const elements = input.elements.map((v) => {
    return {
      element: v.element,
      value: v.value,
    }
  })

  const files = input.files.map((v) => {
    return {
      element: v.element,
      file: v.value,
    }
  })

  const variables: SubmitWebformMutationVariables = {
    id: props.webform.id,
    elements,
    files,
    sourceEntityType: props.sourceEntityType,
    sourceEntityId: props.sourceEntityId,
  }

  const { data, errors } = await useGraphqlUploadMutation(
    'submitWebform',
    variables,
  )

  if (!data || errors?.length) {
    throw new Error('Failed to submit webform.')
  }

  return data.submitWebform
}

const router = useRouter()

function onSuccess({ id, token }: { id?: string; token?: string }) {
  if (id && token) {
    router.push({
      name: 'webform-confirmation',
      params: {
        id,
      },
      query: {
        token,
        webformId: props.webform.id,
      },
    })
  }
}
</script>
